import {connect} from 'react-redux';
import {logOut} from '../actions/creators';
import {Page} from '../../layout/components';
import Spinner from 'react-spin';
import {withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class LogOutPage extends Component {
  componentDidMount() {
    const {logOut, router} = this.props;
    logOut()
      .then(() => router.push('/log-in'))
      .catch(() => router.push('/log-in'));
  }

  render() {
    return (
      <Page pageClassName="log-out-page">
        <h1>Logging out...<Spinner config={{left: '295px', top: '95px'}} /></h1>
      </Page>
    );
  }
}

LogOutPage.propTypes = {
  logOut: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(connect(
  null,
  {
    logOut
  }
)(LogOutPage));



// WEBPACK FOOTER //
// ./app/features/authentication/containers/LogOutPage.js